export default __webpack_public_path__ + "1e824655492eb7819a3e2a6511a70049.svg";